<template>
	<div v-html="blogHtml" class="w-full flex flex-col gap-2 pr-1"></div>
</template>

<script setup>
import { onMounted, ref } from 'vue'

import axios from 'axios'

const blogHtml = ref(null)

const fetchBlog = async () => {
	try {
		const response = await axios.get("/changelog/changelog.html")

		blogHtml.value = response.data
	} catch (error) {
		console.error('Error fetching blogposts:', error)
	}
}

onMounted(()=>{
	fetchBlog()
})
</script>

<style>
.clPost {
	background-color: var(--color-muted-background);

	border-radius: 0.5em;
	overflow: hidden;

	border: 1px solid var(--color-border);

	width: 100%;

	box-sizing: border-box;
}

.clPost h3 {
	margin-top: 0.1em;
	margin-bottom: 0.5em;
}

.clPost p {
	font-size: smaller;

	margin-top: 0.6em;
	margin-bottom: 0.2em;
}

.clContainer {
	position: relative;
}

.clContent {
	position: relative;

	padding: 1em;
	padding-left: 8em;
}

.clImage {
	/* height: 10em; */
	height: 100%;
	width: 10em;

	overflow: hidden;

	/* aspect-ratio: 4/3; */

	position: relative;

	pointer-events: none;
	position: absolute;
	z-index: 0;

	opacity: 0.8;
}


.clImage > img {
	height: 100%;
	width: 100%;
	object-fit: cover;
	object-position: left center;
}

.clImage::before {
	content: '';

	background: 
		linear-gradient(to left, var(--color-muted-background), #00000000),
		linear-gradient(to bottom, #00000000, color-mix(in lab, var(--color-uaqi-1), #0000 50%));

	width: 100%;
	height: 100%;

	display: block;
	position: absolute;

	backdrop-filter: invert(1) hue-rotate(180deg);
}

.dark .clImage::before {
	backdrop-filter: none;
}
</style>